import axios from 'axios';
import { errorHelper, messageHelper } from '../helper.js';
import {
  GET_LIST_COUNCILS_URL,
  COUNCIL_CHANGE_STATUS_URL,
  NEW_COUNCIL_URL,
  COUNCIL_DETAIL_URL,
  MY_PROPOSALS_URL,
  CHANGE_COUNCIL_PROPOSALS_URL,
  CHANGE_COUNCIL_PROPOSAL_EXPERTS_URL,
  CHANGE_COUNCIL_PROPOSAL_SOLUTION_URL,
  NEXT_COUNCIL_STATUS_URL,
  UPDATE_COUNCIL_TIME_URL,
  UPDATE_EXPERT_COUNCIL_RESOLUTION_URL,
  CHANGE_COUNCIL_TEAM_URL,
  SAVE_STATION_TIME_AVAILABLE_URL,
} from '../../../vars';

/**
 * @namespace Proposal
 * @description Жизненный цикл заявки (Page: /proposal/:id)
 */
export default {
  state: {
    councilAll: null,
    councilAccess: null,
  },

  mutations: {
    UPDATE_COUNCIL_ALL(state, data) {
      state.councilAll = data.council;
      state.councilAccess = data.access;

      // state.councilAll.date = g.toDate(state.councilAll.date);
    },

    UPDATE_COUNCIL_AVAILABLE_TIME(state, data) {
      state.councilAll.council_stations.forEach(item => {
        if(item.id == data['id']){
          item.available_time = data['available_time']
        }
      });
    },
  },

  actions: {
      /**
       * Получает список данных по ролям(moderator)
       * @param {Object} ctx 
       * @param {Object} data Данные для получания списка по ролям
       * @returns {Object} Данные резьтатат запроса
       * @throws {Object} Ошибка запроса данных
       * 
       * @memberof RoleList
       */
      async GET_LIST_COUNCILS(ctx, data) {
        // let allUrl = `${GET_LIST_COUNCILS_URL}?status_id=${data.status_id}`;

        try {
          // console.log('GET_LIST_COUNCILS', data)
            const res = await axios.post(`${GET_LIST_COUNCILS_URL}`, {
              status_id:  data.status_id ? data.status_id : 0,
              view_type: data.view_type,
              station_id: data.station_id ? data.station_id : 0,
            },{ headers: {
                  Authorization: `Token ${localStorage.token}`
            }});
            return res
        } catch(e) {
            errorHelper(e)
            messageHelper('', 'error', 6000, e)
            throw e
        }
    },

        
    /**
     * Удаляет COUNCIL
     * @param {Object} ctx 
     * @param {Object} data Данные для удаления COUNCIL
     * @throws {Object} Ошибка запроса данных
     * 
     * @memberof User
     */
    async DELETE_COUNCIL(ctx, data) {
      try {
        const res = await axios.post(`${COUNCIL_CHANGE_STATUS_URL}`, {
              council_id: data.deleteId,
              action: 'delete',
          }, {headers: {
              Authorization: `Token ${localStorage.token}`,
          }});
        return res.data
      } catch(e) {
          errorHelper(e)
          messageHelper('', 'error', 6000, e)
          console.log('DELETE_COUNCIL', e)
          throw e
      }
    },

        
    /**
     * return COUNCIL
     * @param {Object} ctx 
     * @param {Object} data Данные для return COUNCIL
     * @throws {Object} Ошибка запроса данных
     * 
     * @memberof User
     */
    async RETURN_COUNCIL(ctx, data) {
      try {
        const res = await axios.post(`${COUNCIL_CHANGE_STATUS_URL}`, {
              council_id: data.id,
              action: 'return',
          }, {headers: {
              Authorization: `Token ${localStorage.token}`,
          }});
        return res.data
      } catch(e) {
          errorHelper(e)
          messageHelper('', 'error', 6000, e)
          console.log('RETURN_COUNCIL', e)
          throw e
      }
    },

    
    /**
     * NEW COUNCIL
     * @param {Object} ctx 
     * @param {Object} data Данные для NEW COUNCIL
     * @throws {Object} Ошибка запроса данных
     * 
     * @memberof User
     */
    async NEW_COUNCIL(ctx, data) {
      try {
        const res = await axios.post(`${NEW_COUNCIL_URL}`, data, {headers: {
              Authorization: `Token ${localStorage.token}`,
          }});
        return res.data
      } catch(e) {
          errorHelper(e)
          messageHelper('', 'error', 6000, e)
          console.log('NEW_COUNCIL', e)
          throw e
      }
    },

      /**
   * Получает детальную информацию и записывает
   * @param {Object} ctx
   * @param {String|Number} id Идентификатор
   * @throws {Object} Ошибка запроса данных
   *
   * @memberof Main
   */
    async GET_COUNCIL_ALL(ctx, id) {
      try {
        const res = await axios.get(`${COUNCIL_DETAIL_URL}?id=${id}`, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });  
        await ctx.commit('UPDATE_COUNCIL_ALL', res.data);
        // return res.data;
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log(e, ' GET_COUNCIL_ALL');
        throw e;
      }
    },

    async CHANGE_COUNCIL_TEAM(ctx, data) {
      try {
        const res = await axios.post(CHANGE_COUNCIL_TEAM_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return res.data
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log(e, ' CHANGE_COUNCIL_TEAM');
        throw e;
      }
    },  
  
    async GET_AVAILABLE_COUNCIL_PROPOSALS(ctx, data) {
      try {
        const res = await axios.get(`${MY_PROPOSALS_URL}?view_type=available_council_list`, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return res.data
  
        } catch (e) {
          errorHelper(e);
          messageHelper('', 'error', 6000, e);
          console.log(e, ' GET_COUNCIL_ALL');
          throw e;
        }
      },

    async CHANGE_COUNCIL_PROPOSALS(ctx, data) {
      try {
        const res = await axios.post(CHANGE_COUNCIL_PROPOSALS_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return res.data
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log(e, ' CHANGE_COUNCIL_PROPOSALS');
        throw e;
      }
    },  

    async CHANGE_COUNCIL_PROPOSAL_EXPERTS(ctx, data) {
      try {
        const res = await axios.post(CHANGE_COUNCIL_PROPOSAL_EXPERTS_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return res.data
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log(e, 'CHANGE_COUNCIL_PROPOSAL_EXPERTS');
        throw e;
      }
    },  

    async CHANGE_COUNCIL_PROPOSAL_SOLUTION(ctx, data) {
      try {
        const res = await axios.post(CHANGE_COUNCIL_PROPOSAL_SOLUTION_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return res.data
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log(e, 'CHANGE_COUNCIL_PROPOSAL_SOLUTION');
        throw e;
      }
    },  

    async SAVE_STATION_TIME_AVAILABLE(ctx, data) {
      try {
        const res = await axios.post(SAVE_STATION_TIME_AVAILABLE_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        if(res.data.status){
          await ctx.commit('UPDATE_COUNCIL_AVAILABLE_TIME', res.data);
        }
        return res.data
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log(e, 'SAVE_STATION_TIME_AVAILABLE');
        throw e;
      }
    },  

    async NEXT_COUNCIL_STATUS(ctx, data) {
      try {
        const res = await axios.post(NEXT_COUNCIL_STATUS_URL, data, {
          headers: {
            Authorization: `Token ${localStorage.token}`,
          },
        });
        return res.data
      } catch (e) {
        errorHelper(e);
        messageHelper('', 'error', 6000, e);
        console.log(e, 'CHANGE_COUNCIL_PROPOSAL_SOLUTION');
        throw e;
      }
    },  
        
    async UPDATE_COUNCIL_TIME(ctx, data) {
        try {
            const res = await axios.post(UPDATE_COUNCIL_TIME_URL, data, {
                headers: {
                    Authorization: `Token ${localStorage.token}`,
                },
            });
            return res.data;
            } 
        catch (e) {
            errorHelper(e);
            messageHelper('', 'error', 6000, e);
            console.log('UPDATE_COUNCIL_TIME', e);
            throw e;
        }
    },
        
    async UPDATE_EXPERT_COUNCIL_RESOLUTION(ctx, data) {
      try {
          const res = await axios.post(UPDATE_EXPERT_COUNCIL_RESOLUTION_URL, data, {
              headers: {
                  Authorization: `Token ${localStorage.token}`,
              },
          });
          return res.data;
          } 
      catch (e) {
          errorHelper(e);
          messageHelper('', 'error', 6000, e);
          console.log('UPDATE_EXPERT_COUNCIL_RESOLUTION', e);
          //   return {'data' : {'error' : e.message}}
          throw e;
      }
  },
},

  getters: {
    GETTERS_COUNCIL_ALL(state) {
      return state.councilAll;
    },

    GETTERS_COUNCIL_ACCESS(state) {
      return state.councilAccess;
    },
  },
};
